module.exports = ".copy-wrapper {\n    margin: 0 auto;\n    max-width: 650px;\n}\n"